import { render, staticRenderFns } from "./ClientsMenu.vue?vue&type=template&id=5a61e287&"
import script from "./ClientsMenu.vue?vue&type=script&lang=js&"
export * from "./ClientsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports